import SkillItem from "./skill_item";

export default class Assessment {
    readonly id: number
    readonly body: string
    readonly score: number
    readonly skillItemId: number
    readonly enrollmentId: number
    readonly createdAt: string
    readonly updatedAt: string
    readonly enrollmentSkillId: number
    readonly userExamId: number
    readonly qId: number
    readonly totalAnswerItemsAllotment: number
    readonly userId: number
    readonly gradingId: number
    readonly userGoalId: number
    readonly userAssignmentId: number
    readonly testMode: string
    readonly currentAverage: number
    readonly skillItem: SkillItem | undefined


    constructor(data: { [key: string]: any }) {
        this.id = data.id
        this.body = data.body
        this.score = data.score
        this.skillItemId = data.skillItemId
        this.enrollmentId = data.enrollmentId
        this.createdAt = data.createdAt
        this.updatedAt = data.updatedAt
        this.enrollmentSkillId = data.enrollmentSkillId
        this.userExamId = data.userExamId
        this.qId = data.qId
        this.totalAnswerItemsAllotment = data.totalAnswerItemsAllotment
        this.userId = data.userId
        this.gradingId = data.gradingId
        this.userGoalId = data.userGoalId
        this.userAssignmentId = data.userAssignmentId
        this.testMode = data.testMode
        this.currentAverage = data.currentAverage

        if (data.skillItem) {
            this.skillItem = new SkillItem(data.skillItem)
        }
    }
}